import { useEffect, useRef } from "react";
import type { ScrollView } from "tamagui";

import { isPositiveNum } from "~/utils/is-positive-num";
import { useHistory } from "./use-history";

export const useAutoScroll = () => {
  const { prev, next, set, reset } = useHistory(0);
  const scrollRef = useRef<ScrollView | null>(null);

  useEffect(() => {
    if (prev === undefined) return;
    if (prev > next) return;
    if (prev === 0) return;
    const diff = Math.floor(next - prev);

    if (isPositiveNum(diff)) {
      scrollRef.current?.scrollTo({ y: diff });
    }
  }, [prev, next]);

  return {
    trackHeightValue: set,
    scrollRef,
    resetOnClose: reset,
  };
};
